import React, { useState,useEffect } from "react"
import { Nav, Navbar, Container } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { setToken, setUser } from "../../redux/authenticationSlice"
import { UpdateUserDetails } from "../modals/UpdateUserDetails"
import { useAxios } from "../../hooks/useAxios"
import { SuccessNotification } from "../success/SuccessNotification"
import Flags from "country-flag-icons/react/3x2"
import { useTranslation } from "react-i18next"
import i18n from "../../i18n"
export const MainNavigation = () => {
  const { t } = useTranslation()
  const api = useAxios()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const token = useSelector((state) => state.authentication.token)
  const [updateUserDetails, setUpdateUserDetails] = useState(false)
  const successNotification = useSelector((state) => state.flash.success)
  const errorNotification = useSelector((state) => state.flash.error)
  const [bannerHeight,setBannerHeight] = useState(0)
  const logout = async () => {
    try {
      await api.post("logout")
      dispatch(setUser(null))
      dispatch(setToken(null))
      navigate("/")
    } catch (ex) {
      console.log(ex)
    } finally {
    }
  }

  useEffect(()=>{
    const img = new Image()
    img.src = process.env.REACT_APP_BANNER
    console.log(img)
    img.onload = ()=>{
      setBannerHeight(img.height)
      console.log("height",img.height)
    }
  },[token])
  return (
    <>
      <UpdateUserDetails show={updateUserDetails} hide={() => setUpdateUserDetails(false)} />
      <Container
        // style={{ background: `url(${process.env.REACT_APP_BANNER})`, backgroundSize: "cover", minHeight: "100%" }}
        >
        <div style={{ height: bannerHeight }}>
          <img src={`${process.env.REACT_APP_BANNER}`} height={bannerHeight} />
        </div>
      </Container>
      <Navbar bg="light" expand="lg" className="shadow sticky-top">
        <Container>
          <Navbar.Brand className="tw-flex tw-space-x-1">
            <Flags.GB
              id="tipGB"
              title="English"
              className="tw-cursor-pointer tw-h-6"
              onClick={async () => await i18n.changeLanguage("en")}
            />
            <Flags.TR
              title="English"
              className="tw-cursor-pointer tw-h-6"
              onClick={async () => await i18n.changeLanguage("tr")}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto"></Nav>
            {!token && (
              <>
                <Nav.Link as={Link} to="/login" className="float-end btn btn-success ">
                  <i className="fa fa-lock  p-2"></i>Login
                </Nav.Link>
                <Nav.Link as={Link} to="/register" className="float-end btn btn-success ">
                  <i className="fa fa-user-plus  p-2"></i>Register
                </Nav.Link>
              </>
            )}
            {token && (
              <>
                <Nav.Link className="float-end " onClick={() => setUpdateUserDetails(true)}>
                  <i className="fa fa-user mx-2"></i> {t("profile")}
                </Nav.Link>
                <Nav.Link className="float-end " onClick={logout}>
                  <i className="fa fa-sign-out mx-2"></i>
                </Nav.Link>
              </>
            )}
          </Navbar.Collapse>
          {successNotification && <SuccessNotification message={successNotification} />}
        </Container>
      </Navbar>
    </>
  )
}
